
import React, { useEffect, useState } from 'react'
import OrderCountComponent from './OrderCountComponent'
import { getData } from '../../store/utils'
import { useHistory } from "react-router-dom";
import MobileMenuButton from './component/MobileMenuButton';
import { LuLogOut } from 'react-icons/lu';

function OrderDashboard() {
  const history = useHistory(); // Initialize useHistory
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(false)

  const [mergedData, setMergedData] = useState([]);

  const defaultStatuses = [
    { statusName: "Delivered", color: "#2e7d32", bg: "#e6f8ec", statusId: 41 },
    { statusName: "Shipment Pending", color: "#f66d4a", bg: "#fff5e5", statusId: 48 },
    { statusName: "In-transit", color: "#1e40af", bg: "#e6f0ff", statusId: 40 },
    { statusName: "Cancel", color: "#d32f2f", bg: "#ffe6e6", statusId: 50 },
  ];




  useEffect(() => {
    const fetchAndMergeData = async () => {
      setLoading(true);
      try {
        const data = await getData(`lender/orderCount?warehouseId=50`);
        const apiList = data?.data || [];

        const merged = defaultStatuses.map((status) => {
          const match = apiList.find((item) => item.statusName === status.statusName);
          return {
            ...status,
            count: match ? match.count : 0,
            id: match ? match.statusId : status.statusId,
          };
        });




        setMergedData(merged);
        setTotalCount(data?.totalRecords || 0);
      } catch (error) {
        console.error("Error fetching order count:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAndMergeData();
  }, []);



  const handleCardClick = ({ statusId }) => {
    history.push(`/WarehouseOrderList?statusId=${statusId}`);


  };

  const handleLogout = () => {
    // setIsAuthenticated("");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("jwtRefreshToken");
    localStorage.removeItem("USER_ROLE");
    localStorage.removeItem("USER_DATA");
    window.location.href = "/login";
  };



  return (

    <div style={{}}>
      <div className="mb-3 d-flex align-items-center justify-content-between" >
        <img src="../assets/img/daqi_logo2.png" alt="DAQI Logo" width="120px" />

        <div
          // component={<Link to="/login" />}
          // style={isActive("/login") ? activeStyle : {}}

          onClick={handleLogout}
        >
          <LuLogOut style={{ fontSize: 28 }} />
        </div>

      </div>
      <OrderCountComponent count={totalCount} />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          // gap: "20px",
          marginBottom: "20px",
          marginTop: "10px"
        }}
      >

        {mergedData.map((item) => (
          <div
            onClick={() => handleCardClick({ statusId: item.id })}
            key={item.statusName
            }
            style={{
              backgroundColor: item.bg,
              color: item.color,
              margin: '10px',
              padding: "30px",
              borderRadius: "10px",
              textAlign: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ fontSize: "28px", fontWeight: "bold" }}>
              {item.count}
            </div>
            <div style={{ fontSize: "16px", marginTop: "5px", fontWeight: "600", letterSpacing: "1px" }}>
              {item.statusName
              }
            </div>
          </div>
        ))}
      </div>


    </div>
  )
}

export default OrderDashboard



